import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LinkOutlined } from '@ant-design/icons';

import './styles.less';

/**
 * A component that wraps its children in a PageHook container allowing
 * for easy browser navigation to this component.
 */
export const PageHook = ( props ) => {

    // Extract properties from props and cache for use.
    const isValidHook = useMemo( () => Boolean( props.id ), [ props.id ] );
    const isContentClickable = useMemo( () => Boolean( props.clickableContent ), [ props.clickableContent ] );
    const iconVisibility = useMemo( () => props.iconVisibility ? props.iconVisibility : 'hover', [ props.iconVisibility ] );

    // Adds the id to the page path for navigation purposes.
    const useHook = useCallback( () => {
        location.hash = ( isValidHook ) ? `#${ props.id }` : '';
    }, [ isValidHook, props.id ] );

    const containerClasses = classnames(
        'page-hook',
        { 'clickable': isContentClickable && isValidHook },
        { 'icon-on-hover': ( iconVisibility === 'hover' ) },
        { [ props.className ]: Boolean( props.className ) },
    );

    const contentClasses = classnames(
        'page-hook-content',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <div className={ containerClasses } onClick={ isContentClickable ? useHook : undefined }>
            { ( props.iconVisibility !== 'hidden' ) && Boolean( props.id ) &&
                <div className="page-hook-link-icon" onClick={ !isContentClickable ? useHook : undefined }>
                    <LinkOutlined />
                </div>
            }
            <a
                className="hidden-page-hook"
                id={ props.id }
            />
            <div className={ contentClasses } style={ props.style }>
                { props.children }
            </div>
        </div>
    );
};

// The default prop values for the component.
PageHook.defaultProps = {
    className: undefined,
    style: undefined,
    id: undefined,
    iconVisibility: 'hover',
    clickableContent: false,
};

// The typedefs for the props of the component.
PageHook.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    id: PropTypes.string,
    iconVisibility: PropTypes.oneOf( [ 'visible', 'hover', 'hidden' ] ),
    clickableContent: PropTypes.bool,
};
